import $ from 'jquery';
import breakpoint from '../scripts/breakpoint';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-cardProductSlider';
	$(base, context).each(function(i, el){
		var slider;

		function enableSlider() {
			slider = new Swiper (el.querySelector('.b-cardProductSlider-container'), {
				slidesPerView: 'auto',
				spaceBetween: 10,
				slideClass: 'b-cardProduct',
				loop: false,
				watchOverflow: true,
				breakpoints: {
					768: {
						spaceBetween: 20,
					}
				},
			});
		}
	
		breakpoint('xs', 'lg')
			.onmatch(function(){
				return enableSlider();
			})
			.onmismatch(function(){
				if ( slider !== undefined ) slider.destroy( true, true );
					return;
			});
	});
});
